import { isSectionCompleted, sectionHasVisibleQuestions } from "./section";

import { EdhConditionDisclosureResource } from "../types/EdhConditionDisclosureResource";
import { EdhPrimaryPhysicianResource } from "../types/EdhPrimaryPhysicianResource";
import { QuestionPageResource } from "../types/QuestionPageResource";
import { QuestionSectionResource } from "../types/QuestionSectionResource";

/**
 * Returns true if page contains sections with visible questions.
 * @param {QuestionPageResource} page The page to check.
 * @return {boolean} True if page has visible questions, otherwise false.
 * */
export const pageHasVisibleQuestions = (page: QuestionPageResource) => {
  return (
    page.sections.filter((section) => {
      return sectionHasVisibleQuestions(section);
    }).length > 0
  );
};

/**
 * Returns true if all sections in the given page are completed.
 * @param page An interview page.
 */
export const isPageCompleted = (
  page: QuestionPageResource,
  primaryPhysician: EdhPrimaryPhysicianResource[],
  embeddedDisclosures?: EdhConditionDisclosureResource[],
): boolean => {
  return (
    page.sections.filter(
      (section: QuestionSectionResource) =>
        !isSectionCompleted(section, primaryPhysician, embeddedDisclosures),
    ).length === 0
  );
};
